export enum TipoNotaLiquidazioneEnum {
  LIQUIDAZIONE_FATTURA_COMMERCIALE = <any>"LIQUIDAZIONE_FATTURA_COMMERCIALE",
  PAGAMENTO_IMPOSTE = <any>"PAGAMENTO_IMPOSTE",
  LIQUIDAZIONE_CONTRIBUTI = <any>"LIQUIDAZIONE_CONTRIBUTI",
  ALTRO = <any>"ALTRO",
}
